import React from 'react'
import {chakra} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import {flagViewBox} from './flags'

const Svg = chakra('svg', {})

/**
 * Country flag from the shared SVG sprite.
 *
 * Purely decorative — a flag beside a country label says nothing a screen
 * reader has not already read out — so it is always `aria-hidden`; the
 * accessible name belongs on the control that wraps it.
 *
 * Each flag carries its own `viewBox`, so the artwork keeps its natural
 * proportions: a caller sizes one axis and the other follows. The ratios
 * genuinely differ — most flags are 3:2, Ukraine is 4:3 — so a caller that
 * pinned one would letterbox the rest.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.countryCode] - ISO 3166-1 alpha-2 code, case-insensitive.
 * @returns {JSX.Element|null} Null when no flag exists for the country.
 */
const FlagIcon = ({countryCode, ...props}) => {
    const code = countryCode?.toUpperCase()
    const viewBox = code && flagViewBox(code)

    if (!viewBox) {
        return null
    }

    return (
        <Svg role="presentation" aria-hidden="true" focusable="false" viewBox={viewBox} {...props}>
            <use href={`#${code}`} xlinkHref={`#${code}`} width="100%" height="100%" />
        </Svg>
    )
}

FlagIcon.propTypes = {
    countryCode: PropTypes.string
}

if (process.env.NODE_ENV !== 'production') {
    FlagIcon.displayName = 'FlagIcon'
}

export default FlagIcon
